/**
 * Link `state` of a tournament match opened from outside its tournament (the
 * standalone match page's Tournaments tab). Back returns there, so the match
 * page offers a link to the tournament's matches. Read it with
 * `isOpenedOutsideTournament`.
 */
export const OPENED_OUTSIDE_TOURNAMENT_STATE = { openedOutsideTournament: true } as const;

export function isOpenedOutsideTournament(state: unknown): boolean {
  return typeof state === 'object' && state !== null
    && (state as { openedOutsideTournament?: unknown }).openedOutsideTournament === true;
}
